<script>
import Card from "./Card";

export default {
  components: {
    Card
  }
};
</script>

<template>
  <Card
    header="Profissionais"
    text="Os profissionais autônomos disponíveis na plataforma Donamaid são verificados para a segurança de todos."
    imagePath="/static/dashboard/professionals.svg"
  />
</template>



// WEBPACK FOOTER //
// src/components/Dashboard/components/InfoCards/cards/Professionals.vue